import { render, staticRenderFns } from "./CheckSeat.vue?vue&type=template&id=85080020&"
import script from "./CheckSeat.vue?vue&type=script&lang=js&"
export * from "./CheckSeat.vue?vue&type=script&lang=js&"
import style0 from "./CheckSeat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports